import React from "react";
import { DropdownButton, Dropdown, $ } from "../../../../../vendor";

const SidebarMenu = (props) => {
  const onToggleDropdown = (nextShow, meta) => {
    if (nextShow) {
      $(".sticky-top-sortbar").addClass("hide");
    } else {
      $(".sticky-top-sortbar").removeClass("hide");
    }
  };
  return (
    <>
      <aside className="inb-c-item__actions">
        <DropdownButton
          id="dropdown-basic-button"
          title="..."
          variant="secondary"
          drop="up-centered"
          menuAlign="left"
          align="end"
          onToggle={onToggleDropdown}
          bsPrefix="button round inb-toggle-contingent-dd hover"
        >
          <ul className="inb-dropdown__list">
            {props.menu.map((obj, index) => {
              return (
                <>
                  {typeof obj.spacer !== "undefined" && <li className="spacer"></li>}

                  {typeof obj.spacer === "undefined" && (
                    <li data-inb-action-link={obj.title} id={"kln_" + index}>
                      {typeof obj.handler !== "undefined" && (
                        <Dropdown.Item
                          href={obj.href}
                          onClick={
                            obj.href === "#"
                              ? () => {
                                  obj.handler(obj.id);
                                }
                              : () => {}
                          }
                          id={obj.id}
                          target={typeof obj.target !== "undefined" ? obj.target : ""}
                          rel={typeof obj.rel !== "undefined" ? obj.rel : ""}
                        >
                          <i className={obj.iconClass}></i>
                          {obj.text}
                        </Dropdown.Item>
                      )}
                      {typeof obj.handler === "undefined" && (
                        <Dropdown.Item
                          href={obj.href}
                          id={obj.id}
                          target={typeof obj.target !== "undefined" ? obj.target : ""}
                          rel={typeof obj.rel !== "undefined" ? obj.rel : ""}
                        >
                          <i className={obj.iconClass}></i>
                          {obj.text}
                        </Dropdown.Item>
                      )}
                    </li>
                  )}
                </>
              );
            })}
          </ul>
        </DropdownButton>
      </aside>
    </>
  );
};

export default SidebarMenu;
